import { PlanungAdminRoles, PlanungViewerRoles } from '@bp/pim-auth-constants';
import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserPermissionsForm } from '../Forms/UserPermissionsForm';

type UserPermissionsModalProps = {
  isOpen: boolean;
  profileUuid: string;
  name: string;
  onClose: () => void;
  onPermissionsChanged: (
    permissions: Array<PlanungAdminRoles | PlanungViewerRoles>,
    profileUuid?: string | null,
  ) => Promise<void>;
};

export const UserPermissionsModal = ({
  isOpen,
  profileUuid,
  name,
  onClose,
  onPermissionsChanged,
}: UserPermissionsModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal title={t('profile.handlePermissions', { name })} isOpen={isOpen} onRequestClose={onClose}>
      <UserPermissionsForm
        profileUuid={profileUuid}
        onClose={onClose}
        onPermissionsChanged={async (permissions, profileUuid) => {
          await onPermissionsChanged(permissions, profileUuid);
        }}
      />
    </Modal>
  );
};
